export default "__VITE_ASSET__c1127eaf__"